var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneCallEnded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.917 10.817l-.322-.322a.7.7 0 0 1 0-.99l.99-.99c4.648-4.647 12.182-4.647 16.83 0l.99.99a.7.7 0 0 1 0 .99l-1.98 1.98a.7.7 0 0 1-.99 0l-1.98-1.98c-.277-.277-.495-.802-.495-1.188V7.189a10.54 10.54 0 0 0-7.92 0v2.098c0 .396-.218.92-.49 1.193l-1.99 1.99a.7.7 0 0 1-.985-.005L.917 10.807v.01z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCallEnded);
export default __webpack_public_path__ + "static/media/phone-call-ended.4ceab6cdb7eb85017ff78396712bed64.svg";
export { ForwardRef as ReactComponent };